Ext.define('WindowSterownikPreview', {
    extend: 'Ext.ux.window.WindowExd',
    cls: 'custom-preview-window',
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    scrollable: 'y',
    layout: 'fit',
    initComponent: function () {
        this.items = [{
            type: 'container',
            layout: 'fit',
            anchor: 1,
            items: [{
                id: 'closeWindowMobileBtn',
                type: 'component',
                maxHeight: 60,
                layout: {
                    type: 'hbox',
                    align: 'stretch'
                },
                items: [{
                        xtype: 'container',
                        flex: 1
                    }, {
                        xtype: 'button',
                        iconCls: 'iconX',
                        cls: 'close-window-mobile-btn',
                        width: 50,
                        handler: () => this.closeOp()
                }]
            }, {
                type: 'component',
                layout: {
                    type: 'hbox',
                    align: 'stretch'
                },
                maxHeight: 40,
                items: [{
                    xtype: 'label',
                    flex: 1,
                    text: Lang.sterownik.capitalise(),
                    align: 'left',
                    cls: 'window-title-mobile'
                }]
            }, {
                type: 'component',
                layout: {
                    type: 'hbox',
                    align: 'stretch'
                },
                maxHeight: 42,
                items: [{
                    xtype: 'label',
                    flex: 1,
                    align: 'left',
                }, {
                    id: this.id + "bedit",
                    xtype: 'button',
                    iconAlign: 'left',
                    iconCls: "iconEdit",
                    ui: 'btn-secondary-s',
                    text: Lang.edytuj.capitalise(),
                    scope: this,
                    handler: this.edytujObiekt
                }, {
                    id: this.id + "bdelete",
                    xtype: 'button',
                    iconAlign: 'left',
                    iconCls: "iconDelete",
                    ui: 'btn-secondary-s',
                    text: Lang.usun.capitalise(),
                    scope: this,
                    handler: this.usunObiekt
                }]
            }, {
                xtype: 'panelmobileobjectpreview',
                itemId: 'mapPanel',
            }]
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        this.obiektid = obiektid;
        this.obiekt = null;
        this.show();
        this.center();
        this.setKeyMap({
            'ESC': {
                scope: this,
                handler: this.closeOp
            }
        });
        this.mask(Lang.ladowanie);
        let rest = "";
        if (Const.OPTIMALFLAG) {
            rest = "rest/sterowniki/getJointObjectForEdit";
        } else {
            rest = "rest/sterowniki/getObjectForEdit";
        }
        performAjaxLPromise(rest, {id: this.obiektid}).then(data => {
            this.obiekt = data;
            let mapData = {
                [Lang.nazwa]: this.obiekt.nazwadsp,
                [Lang.numer_seryjny]: this.obiekt.serialnumber,
                [Lang.typ]: this.obiekt.devid,
                [Lang.active]: this.obiekt.active ? Lang.tak : Lang.nie,
                [Lang.wersja]: this.obiekt.version,
                [Lang.opis]: this.obiekt.opis
            };
            var mapPanel = this.down('#mapPanel');
            this.manageSelect();
            mapPanel.loadData(mapData);
        }).catch(error => {
            handleCommonCallBackAjaxRPCError(error);
        }).finally(() => {
            this.unmask();
        });
    },
    edytujObiekt: function () {
        if (validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/update")) {
            if (Const.OPTIMALFLAG) {
                this.windowObject = Ext.create('WindowSterownikiOpt', {
                });
            } else {
                this.windowObject = Ext.create('WindowSterowniki', {
                });
            }
            this.windowObject.showW(this.obiektid);
            this.windowObject.on('close', function () {
                this.showW(this.obiektid);
            }, this);
        }
    },
    manageSelect: function () {
        var bedit = Ext.getCmp(this.id + "bedit");
        var bdelete = Ext.getCmp(this.id + "bdelete");
        bdelete.setDisabled(!validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/delete"));
        bedit.setDisabled(!validPrivilegesOperatorComplex(ViewSterowniki.accessPropertyName + "/update"));
    },
    usunObiekt: function () {
        Ext.MessageBox.show({
            title: Lang.usuwanie,
            msg: Lang.czy_napewno_usunac_obiekt,
            buttons: Ext.MessageBox.YESNO,
            scope: this,
            fn: function (btn) {
                if (btn == "yes") {
                    sendAjaxDataJsonRpcL("rest/sterowniki/deleteObject", {
                        id: this.obiektid
                    }, this, function (data) {
                        if (data.status) {
                        } else {
                            Ext.MessageBox.alert(Lang.error, data.error);
                        }
                        this.closeOp();
                    });
                }
            }
        });
    },
    closeOp: function () {
        this.fireEvent("wclose");
        this.close();
    }
});
